var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 241,
    viewBox: "0 0 241 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M198.435 0H41.9906C18.7998 0 0 18.7998 0 41.9906V198.435C0 221.626 18.7998 240.425 41.9906 240.425H198.435C221.626 240.425 240.425 221.626 240.425 198.435V41.9906C240.425 18.7998 221.626 0 198.435 0Z",
    fill: "#0059FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.101 67.3041C131.896 58.219 120.331 55.1263 111.272 60.3453C102.213 65.5644 99.129 77.1624 104.333 86.2474L154.64 173.618C159.846 182.703 171.41 185.796 180.47 180.577C189.529 175.358 192.612 163.76 187.408 154.675L137.101 67.3041Z",
    fill: "url(#paint0_linear_1471_121267)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155.283 99.3893C138.385 90.4975 127.077 102.74 122.13 110.15C121.359 111.309 120.588 112.534 119.946 113.758C119.624 114.402 119.432 114.853 119.303 114.982L112.814 126.322L85.7647 173.294C84.544 175.42 82.8735 177.353 80.8818 178.835C78.89 180.317 76.6412 181.477 74.2641 182.121C69.4453 183.41 64.3053 182.766 59.9363 180.253C55.6316 177.74 52.4191 173.616 51.1341 168.784C49.8492 163.951 50.4917 158.797 52.9975 154.415L99.7069 73.2295L103.176 67.1728C104.847 64.2733 107.224 61.8893 110.051 60.2141C112.942 58.5388 116.155 57.7012 119.496 57.7012H120.203C123.544 57.7012 126.756 58.6032 129.647 60.2141C132.538 61.8893 134.916 64.2733 136.586 67.1728L155.283 99.3893Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1471_121267",
    x1: 175.056,
    y1: 170.171,
    x2: 132.259,
    y2: 97.6507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fb772cdcf6f0df751e8fbc872018c4bd.svg";
export { ForwardRef as ReactComponent };